import axios from "axios";
import { BASE_URL } from "../config/env";
import {
  getAuthToken,
  handleUnauthorized,
  isAuthRequest,
  isUnauthorizedError,
  updateStoredExpiry,
} from "../utils/authSession";

const API_BASE_URL = `${String(BASE_URL).replace(/\/+$/, "")}/api`;

export const getAuthHeader = () => {
  try {
    const token = getAuthToken();
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  } catch (e) {
    console.error("Token read error:", e);
    return {};
  }
};

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    const expiresAt =
      response?.headers?.["x-token-expires-at"] || response?.data?.expires_at;
    if (expiresAt) updateStoredExpiry(expiresAt);

    const code = response?.data?.status_code;
    if (code === 401 && !isAuthRequest(response?.config?.url)) {
      handleUnauthorized();
    }
    return response;
  },
  (error) => {
    if (!isAuthRequest(error?.config?.url) && isUnauthorizedError(error)) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);
